import { SortOptionName } from "@/api/modules/autoQ/productSearch/constants.ts";

export const SORT_INDEX_START = 1;

export const INITIAL_SORT_OPTIONS = [{
    key: "productNumber",
    order: SortOptionName.Ascending,
    index: 1
}];